import chatbot from '@/views/chatbot/Chatbot'

export default [
    {
        path: '/chatbot',
        name: 'chatbot',
        component: chatbot,
        meta: {
            auth: false,
            logging: true,
            pageName: 'AI-비서',
        }
    }
]
